import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

export interface PmsRecordStatus {
  id: number;
  code: string;
  name: string;
  isActive: boolean;
  sortOrder: number;
  createdAt?: string;
  updatedAt?: string;
}

export const usePmsRecordStatuses = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<
    PaginatedApiResponse<PmsRecordStatus> | PmsRecordStatus[]
  >(`${moduleConfig.module.api.list}${q}`, fetcher, { revalidateOnFocus: true });
  const normalized = normalizePaginatedListResponse<PmsRecordStatus>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const usePmsRecordStatus = (id?: number) => {
  const { data, error, isLoading, mutate } = useSWR<PmsRecordStatus>(
    id != null && Number.isFinite(id) && id > 0 ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
